<nz-modal nzClassName="tos-modal" [(nzVisible)]="isVisible" [nzTitle]="modalHeader"
  [nzContent]="modalContent" [nzCloseIcon]="null" [nzFooter]="modalFooter" [nzWidth]="600" nzWrapClassName="vertical-center-modal">

  <ng-template #modalHeader>
    <div class="heading">{{tosConfig.popupHeaderText}}</div>
  </ng-template>

  <ng-template #modalContent>
    <span class="info">
      <span>{{tosConfig.popupBodyText1}}&nbsp;</span>
      <a target="_blank" href="https://gomotive.com/legal/terms-of-service/expense-management-cards/#The-Motive-Platform" class="blue-60">{{tosConfig.hyperlinkText}}</a>
      <span>&nbsp;{{tosConfig.popupBodyText2}}</span>
      <div *ngIf="(dismissCount !== 0 && !hideRemindMeLater)" class="mt-15" i18n>You can snooze this reminder {{remainingDismissCount}} more time(s). After that, you'll need to complete this action to proceed.</div>
    </span>
  </ng-template>

  <ng-template #modalFooter>
    <button *ngIf="!hideRemindMeLater" nz-button nzType="default" (click)="remindMeLater()">
      {{tosConfig.popupSecondaryBtnText}}
    </button>

    <button nz-button nzType="primary" type="submit" (click)="submit()">
      {{tosConfig.popupPrimaryBtnText}}
    </button>
  </ng-template>
</nz-modal>
